import Stack from "@mui/material/Stack";
import {Box} from "@mui/material";
import {s_char_pr} from "../../_signals/s_char_calc";
import {Item} from "../CharStyled";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";
import {s_app_mobile} from "../../_signals/s_app";


export default function CharPR() {
    useSignals();
    return <Item>
        <Stack direction={'column'}>
            <label>Physische Rüstung</label>
            <Box sx={{width: 1 / 2}}>{s_char_pr.value}</Box>
        </Stack>
    </Item>
}